const { sameRunStyleInTextBodies } = require('../utils');

exports.computeUnderlineFromTextBodies = (textBodies, textSelection) => sameRunStyleInTextBodies(textBodies, 'underline', false, { textSelection });
